import { Box, Typography, Paper, Divider, List, ListItem, ListItemText } from '@mui/material';
import { env } from '../config/env';

const AboutPage = () => {
  return (
    <Box>
      <Typography variant="h4" component="h1" gutterBottom align="center">
        About {env.appTitle}
      </Typography>
      
      <Paper elevation={3} sx={{ p: 4, maxWidth: 800, mx: 'auto' }}>
        <Typography variant="body1" paragraph>
          This is a modern React application built with the latest technologies and best practices.
          It serves as a starting point for building robust, scalable, and maintainable web applications.
        </Typography>
        
        <Divider sx={{ my: 3 }} />
        
        <Typography variant="h5" component="h2" gutterBottom>
          Technologies Used
        </Typography>
        
        <List>
          <ListItem>
            <ListItemText 
              primary="React 19" 
              secondary="The latest version of React with improved performance and new features"
            />
          </ListItem>
          <ListItem>
            <ListItemText 
              primary="JavaScript" 
              secondary="For building interactive user interfaces"
            />
          </ListItem>
          <ListItem>
            <ListItemText 
              primary="Redux Toolkit" 
              secondary="For efficient state management with less boilerplate"
            />
          </ListItem>
          <ListItem>
            <ListItemText 
              primary="React Router v7" 
              secondary="For declarative routing and navigation"
            />
          </ListItem>
          <ListItem>
            <ListItemText 
              primary="Material UI v7" 
              secondary="For a beautiful and consistent UI design system"
            />
          </ListItem>
          <ListItem>
            <ListItemText 
              primary="Vite" 
              secondary="For fast development and optimized production builds"
            />
          </ListItem>
        </List>
        
        <Divider sx={{ my: 3 }} />
        
        <Typography variant="h5" component="h2" gutterBottom>
          Environment Configuration
        </Typography>
        
        <Typography variant="body1" paragraph>
          This application supports multiple environments through environment-specific configuration files.
          The current environment is: <strong>{env.appEnv}</strong>
        </Typography>
        
        <Typography variant="body2" color="text.secondary">
          API URL: {env.apiUrl}
        </Typography>
      </Paper>
    </Box>
  );
};

export default AboutPage;
